import { render } from "./AboutComponent.vue?vue&type=template&id=cc597f8a&scoped=true"
const script = {}

import "./AboutComponent.vue?vue&type=style&index=0&id=cc597f8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc597f8a"]])

export default __exports__